export const HEADER_ELEMENTS = Object.freeze({
  AVATAR: 'header/avatar',
  SETTINGS_LINK: 'header/settings_link',
  ACCOUNTS_MENU: 'header/accounts_menu',
  ACCOUNTS_SUBMENU: 'header/accounts_submenu',
});

export const STORE_LAYOUT_ELEMENTS = Object.freeze({
  SUBCATEGORY_LINK: 'store/subcategory_link',
  SEARCH_WITH_GRAPHIC: 'store/search_with_graphic',
  STORE_BANNER_CATEGORY_CARDS: 'store_with_banner/category_cards',
  STORE_BANNER_SEARCH: 'store_with_banner/search',
});

export const ACCOUNT_LIST_PAGE_ELEMENTS = Object.freeze({
  CONTAINER: 'account_list/container',
  CONTAINER_V2: 'account_list/container_v2',
  LOADING_SPINNER: 'account_list/loading_spinner',
});

export const ACCOUNT_PAGE_ELEMENTS = Object.freeze({
  CONTAINER: 'account/container',
  STAT_AMOUNT: 'account/stat_amount',
  MAX_AMOUNT: 'account/max_amount',
  TRANSACTION_ROW: 'account/transaction_row',
  TRANSACTION_NAME: 'account/transaction_name',
  TRANSACTION_VENDOR: 'account/transaction_vendor',
  TRANSACTION_COST: 'account/transaction_cost',
  TRANSACTION_REMAINING_BALANCE: 'account/transaction_remaining_balance',
  FORMA_CARD_MODAL: 'account/forma_card_modal',
});

export const PRETAX_ACCOUNT_PAGE_ELEMENTS = Object.freeze({
  CONTAINER: 'pretax_account/container',
  SELECT: 'pretax_account/select',
  CONTRIBUTIONS_OPTION: 'pretax_account/contributions_option',
});

export const PRETAX_ENROLL_PAGE_ELEMENTS = Object.freeze({
  CONTRIBUTION_LOADING: 'pretax_enroll/loading',
  CONTRIBUTION_CONTAINER: 'pretax_enroll/contribution',
  REVIEW_CONTAINER: 'pretax_enroll/review',
});

export const PRETAX_TRANSACTION_DETAIL_PAGE_ELEMENTS = {
  CONTAINER: 'pretax_transaction_detail/container',
} as const;

export const SETTINGS_PAGE_ELEMENTS = Object.freeze({
  SIDE_NAV_LINK: 'settings/side_nav_link',
  BANK_ACCOUNT_CONNECT_MODAL: 'settings/bank_account_connect_modal',
});

export const SETTINGS_SECURITY_PAGE_ELEMENTS = Object.freeze({
  CONTAINER: 'settings/container',
  FORM_CONTAINER: 'settings/form',
});

export const SETTINGS_PAYMENT_PAGE_ELEMENTS = Object.freeze({
  PRETAX_BANK_CHECK_CONFIRMATION_MODAL:
    'setting_payments/pretax_bank_check_confirmation_modal',
  PAYMENT_CONTAINER: 'setting_payments/payment_container',
});

export const POST_TAX_CARD_LIST_PAGE_ELEMENTS = Object.freeze({
  CONTAINER: 'post_tax_card_list/container',
  CARD_CONTAINER: 'post_tax_card_list/card_container',
});

export const POST_TAX_CARD_NEW_PAGE_ELEMENTS = Object.freeze({
  CONTAINER: 'post_tax_card_new/container',
  BILLING_ADDRESS_CONTAINER: 'post_tax_card_new/billing_address_container',
  SHIPPING_ADDRESS_CONTAINER: 'post_tax_card_new/shipping_address_container',
  STATE_OPTION: 'post_tax_card_new/state_option',
});

export const CLAIM_NEW_PAGE_ELEMENTS = Object.freeze({
  NEW_CLAIM_BUTTON: 'claim_new/new_claim_button',
  NEW_CLAIM: 'claim_new/new_claim',
  VENDOR_NAME: 'claim_new/vendor_name',
  RECEIPT_DATE: 'claim_new/receipt_date',
  ACCOUNT: 'claim_new/account',
  ACCOUNT_OPTION: 'claim_new/account_option',
  CATEGORY: 'claim_new/category',
  CATEGORY_OPTION: 'claim_new/category_option',
  AMOUNT: 'claim_new/amount',
  MONTH: 'claim_new/month',
  YEAR: 'claim_new/year',
  NOTE: 'claim_new/note',
  UPLOAD: 'claim_new/upload',
  LIST_ROW: 'claim_new/list_row',
  LIST_ROW_CELL: 'claim_new/list_row_cell',
  SUBMIT_DATE: 'claim_new/submit_date',
  CLAIM_AMOUNT: 'claim_new/claim_amount',
  SHOW_RECEIPT_MODAL_BUTTON: 'claim_new/show_receipt_modal_button',
  RECEIPT_MODAL: 'claim_new/receipt_modal',
  RECEIPT_IMAGE: 'claim_new/receipt_image',
  CREATE_CLAIM_BUTTON: 'claim_new/create_claim_button',
  claim_new_INFO: 'claim_new/claim_new_info',
  STATUS: 'claim_new/status',
  SUCCESS_INFO: 'claim_new/success_info',
});

export const CLAIM_SUCCESS_PAGE_ELEMENTS = Object.freeze({
  TEXT_CONTAINER: 'claims_success/text_container',
});

export const CLAIMS_PAGE_ELEMENTS = Object.freeze({
  CONTAINER: 'claims/container',
});

export const HSA_SUCCESS_PAGE_ELEMENTS = Object.freeze({
  TEXT_CONTAINER: 'hsa_success/text_container',
});

export const STORE_PAGE_ELEMENTS = Object.freeze({
  CATEGORY_LANDING_SUBCATEGORY_CALLOUT:
    'store/category_landing/subcategory_callout',
  EXPLORE_CATEGORY_CARDS: 'store/explore/category_cards',
  EXPLORE_HEADER: 'store/explore/header',
  EXPLORE_PRODUCT_CARDS: 'store/explore/product_cards',
  PRODUCT_CARD: 'store/product_card',
  PRODUCT_CAROUSEL_CARDS: 'store/product_carousel/cards',
  PRODUCT_LIST_SKELETON: 'store/product_list_skeleton',
  PROMOTION_BANNER: 'store/promotion_banner',
  PROMOTION_LANDING_2023_FEATURED_ITEM_CARD: 'featured-item',
  PROMOTION_LANDING_2023_PERKS_CARD: 'store/promotion_landing_2023/perks_card',
  SEARCH_LOCATION: 'store/search_location',
  SEARCH_LOCATION_BUTTON: 'store/search_location_button',
});

export const MAP_PAGE_ELEMENTS = Object.freeze({
  MAP: 'map/map',
  ACTIVITY: 'map/activity',
  ACTIVITY_OPTION: 'map/activity_option',
  VENDOR_VENUE_TILE: 'map/vendor_venue_tile',
  MAP_CONTAINER: 'map/container',
});

export const PRODUCT_PAGE_ELEMENTS = Object.freeze({
  PRODUCT_TITLE: 'product/product_title',
  PRODUCT_DESCRIPTION: 'product/product_description',
  PRODUCT_PRICE_CONTAINER: 'product/product_price_container',
  PRODUCT_PRICE: 'product/product_price',
  PRODUCT_STRIKEOUT_PRICE: 'product/product_strikeout_price',
  VENDOR_DESCRIPTION: 'product/vendor_description',
  PRODUCT_SHORT_DESCRIPTION: 'vendor/product/shortdescription',
  PRODUCT_LONG_DESCRIPTION: 'vendor/product/longdescription',
  RELATED_OFFERS: 'vendor/product/relatedoffers',
  CHECKOUT_BUTTON: 'vendor/product/purchase_button',
  DIGITAL_HEALTH_PRODUCT: 'vendor/product/digital_health_product',
  DETAILS: 'vendor/product/details',
  SUMMARY: 'vendor/product/summary',
  VARIATIONS: 'vendor/product/variations',
});

export const CHECKOUT_PAGE_ELEMENTS = Object.freeze({
  DOB: 'checkout/dob',
  EMERGENCY_NAME: 'checkout/emergency_name',
  EMERGENCY_PHONE: 'checkout/emergency_phone',
  EMAIL: 'checkout/email',
  PHONE: 'checkout/phone',
  GENDER: 'checkout/gender',
  GENDER_OPTION: 'checkout/gender_option',
  STREET: 'checkout/street',
  STREET_EXT: 'checkout/street_ext',
  LOCALITY: 'checkout/locality',
  STATE: 'checkout/state',
  STATE_OPTION: 'checkout/state_option',
  ZIP: 'checkout/zip',
  IS_CURRENT_MEMBER: 'checkout/is_current_member',
  MEMBERSHIP_NUMBER: 'checkout/membership_number',
  HOME_GYM: 'checkout/home_gym',
  LOCATION: 'checkout/location',
  LOCATION_OPTION: 'checkout/location_option',
  DNA_PROFILE_ACCOUNT_EMAIL: 'checkout/dna_profile_account_email',
  IS_DNA_PROFILE_PRESENT: 'checkout/is_dna_profile_present',
  IS_DNA_PROFILE_PRESENT_OPTION: 'checkout/is_dna_profile_present_option',
  PLACE_ORDER_BUTTON: 'checkout/place_order_button',
});

export const TRANSACTION_PAGE_ELEMENTS = Object.freeze({
  POSTTAX_CARD_TRANSACTION_DETAIL:
    'transaction/posttax_card_transaction_detail',
  PRETAX_CARD_TRANSACTION_DETAIL: 'transaction/pretax_card_transaction_detail',
  PRETAX_CARD_TRANSACTION_DETAIL_CALLOUT:
    'transaction/pretax_card_transaction_detail_callout',
  ORDER_SUCCESS_ALERT: 'transaction/order_success_alert',
});

export const SUBSCRIPTION_PAGE_ELEMENTS = Object.freeze({
  SUBSCRIPTION_INFO: 'subscription/subscription_info',
});

export const EMPLOYEE_PROFILE_ELEMENTS = Object.freeze({
  EMPLOYEE_INFO: 'employee/profile_info',
});

export const CLAIM_LIST_PAGE_ELEMENTS = Object.freeze({
  CONTAINER: 'claim_list/container',
  LIST_CONTAINER: 'claim_list/list_container',
  EMPTY_LIST_CONTAINER: 'claim_list/empty_list_container',
});

export const CLAIM_DETAIL_PAGE_ELEMENTS = Object.freeze({
  CONTAINER: 'claim_detail/container',
  LOADING_CONTAINER: 'claim_detail/loading_container',
});

export const ACCORDION_PAGE_ELEMENTS = Object.freeze({
  SVG_ONCLICK: 'svg/onclick',
});

export const PAYMENT_OPTIONS_PAGE_ELEMENTS = Object.freeze({
  PAYMENT_MODAL_BUTTON: 'payment_options/payment_modal_button',
  WALLET_SWITCH: 'payment_options/wallet_switch',
  CC_SWITCH: 'payment_options/cc_switch',
});

export const FORMA_CARD_LIST_PAGE_ELEMENTS = Object.freeze({
  CONTAINER: 'forma_card_list/container',
});

export const HSA_INVESTMENTS_PAGE_ELEMENTS = Object.freeze({
  TOTAL_INVESTED: 'account_enroll_hsa/total_invested',
});

export const WELCOME_EMPLOYER_SPONSORED_INFO_PAGE_ELEMENTS = Object.freeze({
  LOADING_SPINNER: 'welcome_employer_sponsored/loading_spinner',
  PROGRESS_BAR: 'welcome_employer_sponsored/progress_bar',
});

export const WELCOME_PRETAX_PAGE_ELEMENTS = Object.freeze({
  LOADING_SPINNER: 'welcome_pretax/loading_spinner',
  PROGRESS_BAR: 'welcome_pretax/progress_bar',
});

export const HSA_BULK_TRANSFER_ELEMENTS = {
  NON_ALEGEUS_MODAL: 'hsa_bulk_transfer/other',
  NON_ALEGEUS_MODAL_CTA: 'hsa_bulk_transfer/other-cta',
  NON_ALEGEUS_MODAL_TERMS: 'hsa_bulk_transfer/terms',
  ALEGEUS_MODAL: 'hsa_bulk_transfer/alegeus',
  ALEGEUS_MODAL_CTA: 'hsa_bulk_transfer/alegeus-cta',
  DECLINE_PAGE_CTA: 'decline_hsa_bulk_transfer/cta',
  ALEGEUS_BULK_TRANSFER_CONTAINER: 'hsa_bulk_transfer/alegeus-opt-in-page',
  ALEGEUS_BULK_TRANSFER_EMPTY_ICON: 'hsa_bulk_transfer/empty-icon',
  ALEGEUS_BULK_TRANSFER_PAUSED_ICON: 'hsa_bulk_transfer/paused-icon',
  ALEGEUS_BULK_TRANSFER_FILLED_ICON: 'hsa_bulk_transfer/filled-icon',
  /*
    Banner Decoder    
      Name: AL = Alegeus, NAL = Non-Alegeus Custodian  
      Size: SM, LG  
      Location: ST = Store, AL = Accounts List, OH = Alegeus HSA Detail, NH = Forma HSA Detail  
      Type: TR = Transfer, MI = Missed Opt-In, 
            CO = Opt-in confirmed (NAL only), 
            RE = Remind to sell investments (AL only), 217 = Temporary Hold or Removal of Old HSA from Forma (AL only)
      Variant: V1, V2, etc.
  */
  AL_SM_ST_TR_V1_BANNER: 'hsa_bulk_transfer/AL_SM_ST_TR_V1_BANNER',
  AL_LG_AL_TR_V1_BANNER: 'hsa_bulk_transfer/AL_LG_AL_TR_V1_BANNER',
  AL_LG_OH_TR_V1_BANNER: 'hsa_bulk_transfer/AL_LG_OH_TR_V1_BANNER',
  AL_LG_NH_TR_V1_BANNER: 'hsa_bulk_transfer/AL_LG_NH_TR_V1_BANNER',
  AL_LG_AL_OH_NH_TR_V1_BANNER: 'hsa_bulk_transfer/AL_LG_AL_OH_NH_TR_V1_BANNER',

  AL_SM_ST_RE_V1_BANNER: 'hsa_bulk_transfer/AL_SM_ST_RE_V1_BANNER',
  AL_LG_AL_OH_NH_RE_V1_BANNER: 'hsa_bulk_transfer/AL_LG_AL_OH_NH_RE_V1_BANNER',

  AL_SM_ST_MI_V1_BANNER: 'hsa_bulk_transfer/AL_SM_ST_MI_V1_BANNER',
  AL_LG_AL_OH_MI_V1_BANNER: 'hsa_bulk_transfer/AL_LG_AL_OH_MI_V1_BANNER',
  AL_LG_AL_MI_V1_BANNER: 'hsa_bulk_transfer/AL_LG_AL_MI_V1_BANNER',
  AL_LG_OH_MI_V1_BANNER: 'hsa_bulk_transfer/AL_LG_OH_MI_V1_BANNER',
  AL_LG_NH_MI_V1_BANNER: 'hsa_bulk_transfer/AL_LG_NH_MI_V1_BANNER',

  AL_SM_ST_217_BANNER: 'hsa_bulk_transfer/AL_SM_ST_217_BANNER',
  AL_LG_AL_OH_NH_217_BANNER: 'hsa_bulk_transfer/AL_LG_AL_OH_NH_217_BANNER',
  AL_SM_ST_217_V2_BANNER: 'hsa_bulk_transfer/AL_SM_ST_217_V2_BANNER',
  AL_LG_AL_OH_217_BANNER: 'hsa_bulk_transfer/AL_LG_AL_OH_217_BANNER',
  AL_LG_NH_217_BANNER: 'hsa_bulk_transfer/AL_LG_NH_217_BANNER',
  AL_CALLOUT_217_V1: 'hsa_bulk_transfer/AL_CALLOUT_217_V1',
  AL_CALLOUT_217_V2: 'hsa_bulk_transfer/AL_CALLOUT_217_V2',

  NAL_SM_ST_TR_V1_BANNER: 'hsa_bulk_transfer/NAL_SM_ST_TR_V1_BANNER',
  NAL_LG_AL_TR_V1_BANNER: 'hsa_bulk_transfer/NAL_LG_AL_TR_V1_BANNER',
  NAL_LG_NH_TR_V1_BANNER: 'hsa_bulk_transfer/NAL_LG_NH_TR_V1_BANNER',

  NAL_SM_ST_AL_NH_CO_V1_BANNER:
    'hsa_bulk_transfer/NAL_SM_ST_AL_NH_CO_V1_BANNER',

  NAL_SM_AL_NH_MI_V1_BANNER: 'hsa_bulk_transfer/NAL_SM_AL_NH_MI_V1_BANNER',

  AL_CALLOUT_TR: 'hsa_bulk_transfer/AL_CALLOUT_TR',
  AL_CALLOUT_RE: 'hsa_bulk_transfer/AL_CALLOUT_RE',
} as const;
